// "use client"

// import Link from "next/link"
// import { useState } from "react"
// import { Menu, X } from "lucide-react"

// import Image from "next/image"

// export function Header() {
//   const [isOpen, setIsOpen] = useState(false)

//   return (
//     <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-gray-200">
//       <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        
//         <Link href="/" className="flex items-center gap-3">
//           {/* 🔹 Company Logo */}
//           <Image
//             src="/logo.png" // 👈 put your logo file in /public/logo.png
//             alt="Codify Institute Logo"
//             width={100}
//             height={100}
//             className="rounded-lg object-contain"
//             priority
//           />
          
//         </Link>

//         {/* Desktop Navigation */}
//         <div className="hidden md:flex items-center gap-8">
//           <Link href="/courses" className="text-gray-600 hover:text-primary-blue transition">
//             Courses
//           </Link>
//           <Link href="/about" className="text-gray-600 hover:text-primary-blue transition">
//             About
//           </Link>
//           <Link href="/instructors" className="text-gray-600 hover:text-primary-blue transition">
//             Instructors
//           </Link>
//           <Link href="/events" className="text-gray-600 hover:text-primary-blue transition">
//             Events
//           </Link>
//           <Link href="/blog" className="text-gray-600 hover:text-primary-blue transition">
//             Blog
//           </Link>
//           <Link href="/offline-lectures" className="text-gray-600 hover:text-primary-blue transition">
//             Offline Lectures
//           </Link>
//         </div>

//         <div className="hidden md:flex items-center gap-4">
//           <Link href="/contact" className="text-gray-600 hover:text-primary-blue transition font-medium">
//             Contact
//           </Link>
//           <Link
//             href="/admissions"
//             className="bg-primary-blue text-white px-6 py-2 rounded-lg hover:bg-primary-blue-dark transition font-medium"
//           >
//             Apply Now
//           </Link>
//         </div>

//         {/* Mobile Menu Button */}
//         <button className="md:hidden p-2" onClick={() => setIsOpen(!isOpen)}>
//           {isOpen ? <X size={24} /> : <Menu size={24} />}
//         </button>
//       </nav>

//       {/* Mobile Navigation */}
//       {isOpen && (
//         <div className="md:hidden bg-white border-t border-gray-200 p-4 space-y-4">
//           <Link href="/courses" className="block text-gray-600 hover:text-primary-blue">
//             Courses
//           </Link>
//           <Link href="/about" className="block text-gray-600 hover:text-primary-blue">
//             About
//           </Link>
//           <Link href="/instructors" className="block text-gray-600 hover:text-primary-blue">
//             Instructors
//           </Link>
//           <Link href="/events" className="block text-gray-600 hover:text-primary-blue">
//             Events
//           </Link>
//           <Link href="/blog" className="block text-gray-600 hover:text-primary-blue">
//             Blog
//           </Link>
//           <Link href="/offline-lectures" className="block text-gray-600 hover:text-primary-blue">
//             Offline Lectures
//           </Link>
//           <Link href="/contact" className="block text-gray-600 hover:text-primary-blue">
//             Contact
//           </Link>
//           <Link
//             href="/admissions"
//             className="block w-full bg-primary-blue text-white px-6 py-2 rounded-lg text-center font-medium"
//           >
//             Apply Now
//           </Link>
//         </div>
//       )}
//     </header>
//   )
// }
"use client";

import Link from "next/link";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import Image from "next/image";
import { motion, AnimatePresence } from "framer-motion";

export function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-gray-200 shadow-sm">
      {/* ✅ Full-width nav (no horizontal padding at all) */}
      <nav className="w-full h-24 flex items-center justify-between px-4 md:px-10">
        {/* 🔹 Logo – perfectly flush left */}
        <Link href="/" className="flex items-center">
          <Image
            src="/logo.png"
            alt="Codify Institute Logo"
            width={200}
            height={200}
            className="object-contain select-none"
            priority
          />
        </Link>

        {/* 🔹 Desktop Navigation */}
        <div className="hidden md:flex items-center gap-10 ml-auto">
          {[
            // { href: "/courses", label: "Courses" },
            { href: "/about", label: "About" },
            { href: "/syallabus", label: "Courses" },
            // { href: "/placements", label: "Placements" },
            // { href: "/blog", label: "Blog" },
            // { href: "/offline-lectures", label: "Offline Lectures" },
            { href: "/contact", label: "Contact" },
          ].map(({ href, label }) => (
            <Link
              key={href}
              href={href}
              className="text-gray-700 hover:text-blue-600 font-medium transition"
            >
              {label}
            </Link>
          ))}

          <Link
            href="/contact"
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-white hover:text-blue-600 hover:border hover:border-blue-600 transition font-semibold shadow-sm"
          >
            Enquiry Now
          </Link>
        </div>

        {/* 🔹 Mobile Menu Button */}
        <button
          className="md:hidden w-11 h-11 flex items-center justify-center rounded-lg border border-gray-300 hover:bg-gray-100 transition"
          onClick={() => setIsOpen(!isOpen)}
        >
          <motion.div
            animate={isOpen ? { rotate: 180 } : { rotate: 0 }}
            transition={{ duration: 0.3 }}
          >
            {isOpen ? (
              <X size={26} className="text-gray-800" />
            ) : (
              <Menu size={26} className="text-gray-800" />
            )}
          </motion.div>
        </button>
      </nav>

      {/* 🔹 Mobile Navigation */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.25 }}
            className="md:hidden bg-white border-t border-gray-200 shadow-lg p-5 space-y-4"
          >
            {[
              // { href: "/courses", label: "Courses" },
              { href: "/about", label: "About" },
              { href: "/syallabus", label: "Courses" },
              // { href: "/instructors", label: "Instructors" },
              // { href: "/events", label: "Events" },
              // { href: "/blog", label: "Blog" },
              // { href: "/offline-lectures", label: "Offline Lectures" },
              { href: "/contact", label: "Contact" },

            ].map(({ href, label }) => (
              <Link
                key={href}
                href={href}
                className="block text-gray-700 hover:text-blue-600 font-medium"
                onClick={() => setIsOpen(false)}
              >
                {label}
              </Link>
            ))}

            <Link
              href="/contact"
              className="block w-full bg-blue-600 text-white py-2 rounded-lg text-center font-semibold hover:bg-white hover:text-blue-600 hover:border hover:border-blue-600 transition"
              onClick={() => setIsOpen(false)}
            >
              Enquiry Now
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
